import type {
  PurchaseResponse,
  MyPurchaseResponse,
  PaginatedResponse,
} from '@@/types/api';
import { useApi } from './use-api';

// POST /{event}/purchases returns the PurchaseResponse UNWRAPPED (the backend
// resource sets `$wrap = null`) — no `{ data }` envelope. See #1980.
export function usePurchasesApi() {
  const { get, post } = useApi('/api/v1/events');

  return {
    getMyPurchase: (eventId: string) =>
      get<PurchaseResponse | null>(`/${eventId}/purchases/mine`),
    getMyPurchases: (params?: { page?: number; per_page?: number }) =>
      get<PaginatedResponse<MyPurchaseResponse>>('/purchases/mine', {
        params,
      }),
    purchaseTicket: (
      eventId: string,
      body: Record<string, unknown>,
      idempotencyKey?: string,
    ) =>
      post<PurchaseResponse>(`/${eventId}/purchases`, {
        body,
        ...(idempotencyKey
          ? { headers: { 'Idempotency-Key': idempotencyKey } }
          : {}),
      }),
  };
}
